






























import { Component, Prop} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import BillingMixin from '@/mixins/billing-mixin';

@Component({})
export default class ManageAddonEstimate extends mixins(PlanLimitsMixin, BillingMixin) {
  @Prop({ default: {} })
  estimate: any;

  @Prop({ default: {} })
  data: {
    planLimit: null | keyof BillingLimits
  };
}
